import React, { useEffect, useContext, useState, useRef } from "react";
import { useHistory } from "react-router-dom";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  formatPrice,
  currencySymbolRight,
  getSystemSettings,
} from "../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Moment from "react-moment";
import moment from 'moment';
import Select from "react-select";
import { useReactToPrint } from "react-to-print";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

//pages & includes
import ReportSidebar from "./ReportSidebar";

//context consumer
import { SettingsContext } from "../../../../contexts/Settings";
import { RestaurantContext } from "../../../../contexts/Restaurant";
import { UserContext } from "../../../../contexts/User";
import CustomSpinLoader from "../../../components/CustomSpinLoader";

const ExpenseReport = () => {
  const { t } = useTranslation();
  const history = useHistory();
  //getting context values here
  let { loading, setLoading, dataPaginating, generalSettings } =
    useContext(SettingsContext);
  let { branchForSearch } = useContext(RestaurantContext);
  const { authUserInfo } = useContext(UserContext);
  let [newExpenseReport, setNewExpenseReport] = useState(null);

  //all data
  const [reportData, setReportData] = useState(null);

  const componentRef = useRef();
  //settle order
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [generatedReport, setGeneratedReport] = useState(false);
  const [siteName, setSiteName] = useState("");
  //useEffect == componentDidMount()
  const [branchSearch, setBranchSearch] = useState(null);

  useEffect(() => {
    setSiteName(getSystemSettings(generalSettings, "siteName"));
    if (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") {
      setBranchSearch(
        branchForSearch.filter(
          (branch) => branch.id === authUserInfo.details.branch_id
        )
      );
    } else {
      setBranchSearch(branchForSearch);
    }
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, [generalSettings]);

  //Print Report
  const ReportPrint = useRef();

  const handlePrintBtn = useReactToPrint({
    content: () => ReportPrint.current,
  });

  const handleBranch = (branch) => {
    setNewExpenseReport({
      ...newExpenseReport,
      branch,
    });
    // setBranch(branch);
  };

  //get BranchWise reports filter
  const getBranchWiseSelected = () => {
    setReportData(null);
    console.log("newExpenseReport ", newExpenseReport);
    if(
      (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
      !newExpenseReport?.branch[0]?.id
    ){
       toast.error(`${_t(t("Please select Branch to generate report"))}`, {
        position: "bottom-center",
        closeButton: false,
        autoClose: 10000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        className: "text-center toast-notification",
      });
      return;
    }
    if (
      // newExpenseReport?.branch?.id !== null &&
      startDate !== null &&
      endDate !== null
    ) {
      setLoading(true);
      let fromDate = moment(startDate).format("YYYY-MM-DD");
      let toDate =  moment(endDate).format("YYYY-MM-DD");

      const url = BASE_URL + "/settings/get-expense-report";
      const branch = newExpenseReport?.branch && newExpenseReport.branch?.length ? JSON.stringify(newExpenseReport?.branch.map((branch)=>branch.id)) : "";

      let formData = new FormData();
      formData.append("fromDate", fromDate);
      formData.append("toDate", toDate);
      formData.append("branch_id", branch);
      console.log("formData ", formData);

      return axios
        .post(url, formData, {
          headers: { Authorization: `Bearer ${getCookie()}` },
        })
        .then((res) => {
          console.log("ExpenseReportResult", res);
          setReportData(res.data[0]);

          setLoading(false);
          setGeneratedReport(true);
          componentRef.current.handleDownload();
          setNewExpenseReport(null);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      toast.error(
        `${_t(t("Please select from date, to date and generate report"))}`,
        {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        }
      );
    }
  };

  let total_amount = 0;

  return (
    <>
      <Helmet>
        <title>{_t(t("Expense Report"))}</title>
      </Helmet>
      <ReactHTMLTableToExcel
        id="test-table-xls-button"
        className="download-table-xls-button btn btn-success float-right mr-3 invisible"
        table="table-to-xls"
        filename="Expense Report"
        sheet="sheet 1"
        buttonText="Print Expense"
        ref={componentRef}
      />

      {/* Print Button */}
      <div className="d-none">
        <div>
          <div className="fk-print">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  {reportData !== null &&
                    reportData !== undefined &&
                    generatedReport === true && (
                      <>
                        <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                          {console.log("reportData", reportData)}
                          <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                            <table
                              className="table table-bordered table-hover min-table-height mt-3"
                              id="table-to-xls"
                            >
                              <div className="page-break"></div>
                              <thead className="align-middle">
                                <tr style={{ border: "0px" }}>
                                  <th colspan="10" style={{ border: "0px" }}>
                                    <div className="row">
                                      <div className="col-12">
                                        <h3 className="text-center mb-0">
                                          {siteName}
                                        </h3>
                                        <h3 className="text-center mt-0">
                                          Expense Report
                                        </h3>
                                        <p className="text-center">
                                          FROM&nbsp;
                                          <Moment format="LL">
                                            {startDate}
                                          </Moment>
                                          &nbsp;TO&nbsp;
                                          <Moment format="LL">{endDate}</Moment>
                                        </p>
                                      </div>
                                    </div>
                                  </th>
                                </tr>
                                <tr>
                                 <th></th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("S/L"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Document Identity"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Document Date"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("User Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Expense Type"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Party Name"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Payment Type"))}
                                  </th>
                                  <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Remarks"))}
                                  </th>
                                  <th
                                    scope="col"
                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                  >
                                    {_t(t("Amount"))}
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="align-middle">
                                {/* loop here*/}
                                {reportData && Object.keys(reportData).map((group_name, index) => {
                                  let total = 0;                                  
                                  return (
                                  <div key={index}>
                                    <tr>
                                    <th
                                      scope="row"
                                      className="lg-text text-capitalize align-middle text-center"
                                        >
                                        {group_name}
                                        </th>
                                    </tr>
                                    {reportData && reportData[group_name].map((item, i) => {
                                      total_amount += parseInt(item.amount);
                                      total += parseInt(item.amount);
                                        return(
                                          <tr>
                                            <td>
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {i + 1}
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {item.document_identity}
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              <Moment format="LL">
                                              {item.document_date}
                                              </Moment>
                                            </td>
                                            <td
                                            scope="row"
                                            className="xsm-text text-capitalize align-middle text-center"
                                            >
                                            {item.user_name}
                                            </td>
                                            
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {item.expense_name}
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {item.party_name ? item.party_name : "-"}
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {item.payment_type}
                                            </td>
                                            <td
                                            scope="row"
                                            className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {item.remarks ? item.remarks : "-"}
                                            </td>
                                            <td
                                              scope="row"
                                              className="xsm-text text-capitalize align-middle text-center"
                                            >
                                              {item.amount}
                                            </td>{" "}
                                          </tr>
                                        )
                                      })
                                    }
                                    <tr>
                                      <th
                                        colspan="8"
                                        style={{ border: "0px" }}
                                      ></th>
                                      <th className="sm-text text-capitalize align-middle text-center border-1 border">
                                        Total
                                      </th>
                                      <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                        {formatPrice(total)}
                                      </td>
                                    </tr>
                                   </div>
                                  )
                                })}
                                <tr>
                                  <th
                                    colspan="8"
                                    style={{ border: "0px" }}
                                  ></th>
                                  <th className="sm-text text-capitalize align-middle text-center border-1 border">
                                    Grand Total
                                  </th>
                                  <td className="sm-text text-capitalize align-middle text-center border-1 border">
                                    {formatPrice(total_amount)}
                                  </td>
                                </tr>
                              </tbody>
                              <tfoot style={{ border: "0px" }}>
                                <tr style={{ border: "0px" }}>
                                  <td
                                    colspan="7"
                                    className="text-center"
                                    style={{ border: "0px" }}
                                  >
                                    <h5 className="mt-3">
                                      Powered by indolj.pk
                                    </h5>
                                  </td>
                                </tr>
                              </tfoot>
                            </table>
                          </div>
                        </div>
                      </>
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* main body */}
      <main id="main" data-simplebar>
        <div className="container-fluid">
          <div className="row t-mt-10 gx-2">
            {/* left Sidebar */}
            <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
              <ReportSidebar />
            </div>
            {/* left Sidebar ends */}

            {/* Rightbar contents */}
            <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
              <div className="t-bg-white">
                <div
                  className="fk-scroll--pos-menu table-bottom-info-hide"
                  data-simplebar
                >
                  <div className="t-pl-15 t-pr-15">
                    {/* next page data spin loading */}
                    <CustomSpinLoader loading={loading || dataPaginating}/>
                    {/* spin loading ends */}

                    {/* Loading effect */}
                    {/* {loading === true ? (
                      tableLoading()
                    ) : ( */}
                      <div key="smtp-form">
                        <div className="row gx-2 align-items-center t-pt-15 t-pb-15">
                          <div className="col-12 t-mb-15 mb-md-0">
                            <ul className="t-list fk-breadcrumb">
                              <li className="fk-breadcrumb__list">
                                <span className="t-link fk-breadcrumb__link text-capitalize">
                                  {_t(t("Expense Report"))}
                                </span>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <div className="row gx-2 mt-2">
                          <div className="col-md-2 d-md-block">
                            <DatePicker
                              selected={startDate}
                              onChange={(date) => setStartDate(date)}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control sm-text py-2 t-mb-15 mb-md-0"
                              placeholderText={_t(t("From date"))}
                              shouldCloseOnSelect={true}
                            />
                          </div>
                          <div className="col-md-2 t-mb-15 mb-md-0">
                            <DatePicker
                              selected={endDate}
                              onChange={(date) => setEndDate(date)}
                              peekNextMonth
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              className="form-control sm-text py-2"
                              placeholderText={_t(t("To date"))}
                              shouldCloseOnSelect={true}
                            />
                          </div>
                          <div className="col-md-4 t-mb-15 mb-md-0">
                            <Select
                              options={branchSearch && branchSearch}
                              getOptionLabel={(option) => option.name}
                              getOptionValue={(option) => option.id}
                              value={newExpenseReport?.branch && newExpenseReport?.branch}
                              classNamePrefix="select"
                              className="sm-text "
                              onChange={handleBranch}
                              isMulti
                              maxMenuHeight="200px"
                              placeholder={_t(t("Select a branch")) + ".."}
                            />
                          </div>
                          <div className="col-4 t-mb-15 mb-md-0 d-none d-md-block text-right">
                            {/* Action Button */}
                            <button
                              className="btn btn-block btn-primary text-uppercase sm-text py-2 rounded"
                              onClick={(e) => getBranchWiseSelected(e)}
                            >
                              Expense Report
                            </button>
                          </div>
                        </div>
                      </div>
                    {/* )} */}
                  </div>
                </div>
              </div>
            </div>
            {/* Rightbar contents end*/}
          </div>
        </div>
      </main>
      {/* main body ends */}
    </>
  );
};

export default ExpenseReport;
